// @ts-nocheck
import {
  ADD_TRAVEL_DAYS_FAILURE,
  ADD_TRAVEL_DAYS_REQUEST,
  ADD_TRAVEL_DAYS_SUCCESS,
  CLOSE_TRAVEL_DAYS_MODAL,
  OPEN_TRAVEL_DAYS_MODAL,
} from "../../constants/position/travelDays";

const initialState = {
  travelDaysState: false,
  isLoading: false,
  positions: null,
};

const travelDaysReducer = (state = initialState, action) => {
  switch (action?.type) {
    case OPEN_TRAVEL_DAYS_MODAL:
      return {
        travelDaysState: true,
        positions: action?.payload?.positions,
      };

    case CLOSE_TRAVEL_DAYS_MODAL:
      return {
        travelDaysState: false,
        positions: null,
      };

    // add travel data
    case ADD_TRAVEL_DAYS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_TRAVEL_DAYS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case ADD_TRAVEL_DAYS_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default travelDaysReducer;
export { initialState };